//Margin conventions
var margin = {top: 0, right: 75, bottom:20, left: 5};

var widther = d3.select(".gia-chart").node().clientWidth;

var width = widther - margin.left - margin.right,
    height = 430 - margin.top - margin.bottom;

//Appends the svg to the chart-container div
var svg = d3.select(".gia-chart").append("svg")
  .attr("width", width + margin.left + margin.right)
  .attr("height", height + margin.top + margin.bottom)
  .append("g")
  .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

//Creates the xScale 
var xScale = d3.scale.linear()
  .range([0,width]);

//Creates the yScale
var y0 = d3.scale.ordinal()
  .rangeBands([height, 0], 0.4)
  .domain(["HBC", "Target", "Gap", "VF", "Walmart"]);

//Defines the y axis styles
var yAxis = d3.svg.axis()
  .scale(y0)
  .tickSize(-width)
  .tickPadding(4)
  .ticks(4)
  .orient("left");

//Defines the x axis styles
var xAxis = d3.svg.axis()
  .scale(xScale)
  .tickPadding(0)
  .tickSize(height)
  .orient("bottom")
  .tickFormat(function(d) { return d + "%"; })
  .ticks(numTicks(width));

//Defines the x axis styles
var xAxisADDED = d3.svg.axis()
  .scale(xScale)
  .tickPadding(0)
  .tickSize(5)
  .orient("bottom")
  .tickFormat(function(d) { return d; })
  .ticks(numTicks(width));  

//Loads the data
d3.tsv("data/safetyHazards.tsv", ready);

function ready(err, data) {

  if (err) throw "error loading data";

  //FORMAT data
  data.forEach(function(d) {
    d.fire = +d.fire;
    d.alarm = +d.alarm;
  });

  //Sets the max for the xScale
  var maxX = d3.max(data, function(d) { return d.fire; });

  //Defines the xScale max
  xScale.domain([0, 80 ]);

  //Appends the y axis
  var yAxisGroup = svg.append("g")
    .attr("class", "y axis")
    .call(yAxis)
    .attr("transform", "translate(0,8)"); 

  //Binds the data to the bars      
  var categoryGroup = svg.selectAll(".g-category-group")
    .data(data)
    .enter()
    .append("g")
    .attr("class", "g-category-group")
    .attr("transform", function(d) {
      return "translate(0," + y0(d.company) + ")";
    });

  //Appends first bar   
  var bars = categoryGroup.append("rect")
    .attr("width", function(d) { return xScale(d.fire); })
    .attr("height", y0.rangeBand()/2.7 )
    .attr("class", "g-fire")
    .attr("transform", "translate(56,4)");

  //Appends second bar   
  var bars2 = categoryGroup.append("rect")
    .attr("width", function(d) { return xScale(d.alarm); })
    .attr("height", y0.rangeBand()/2.7 )
    .attr("class", "g-alarm")
    .attr("transform", "translate(56,23)");  

  //Appends third bar   
  var bars3 = categoryGroup.append("rect")
    .attr("width", function(d) { return xScale(d.structural); })
    .attr("height", y0.rangeBand()/2.7 )
    .attr("class", "g-structural")
    .attr("transform", "translate(56,42)");     

  //Appends the x axis    
  var xAxisGroup = svg.append("g")
    .attr("class", "x axis")
    .call(xAxis)
    .attr("transform", "translate(56,0)");   

  //Appends the x axis    
  var xAxisGroup = svg.append("g")
    .attr("class", "x axis added")
    .call(xAxisADDED)
    .attr("transform", "translate(56,400)");   
  
  //Binds data to labels
  var labelGroup = svg.selectAll(".g-label-group")
    .data(data)
    .enter()
    .append("g")
    .attr("class", "g-label-group")
    .attr("transform", function(d) {
      return "translate(0," + y0(d.company) + ")";
    });

  //Appends first bar labels   
  var barLabels = labelGroup.append("text") 
    .text(function(d) {return  d.fire + "%";})
    .attr("x", function(d) { return xScale(d.fire) + 60; })
    .attr("y", y0.rangeBand()/2.6 )
    .attr("class", "g-labels");    

  //Appends second bar labels   
  var barLabels2 = labelGroup.append("text") 
    .text(function(d) {return  d.alarm + "%";})
    .attr("x", function(d) { return xScale(d.alarm) + 60; })
    .attr("y", y0.rangeBand()/1.25 )
    .attr("class", "g-labels");    

  //Appends second bar labels   
  var barLabels3 = labelGroup.append("text") 
    .text(function(d) {return  d.structural + "%";})
    .attr("x", function(d) { return xScale(d.structural) + 60; })
    .attr("y", y0.rangeBand()/0.825 )
    .attr("class", "g-labels");      

//RESPONSIVENESS
  d3.select(window).on("resize", resized);

  function resized() {

    //new margin
    var newMargin = {top: 0, right: 75, bottom:20, left: 5};

    var newWidther = d3.select(".gia-chart").node().clientWidth;

    var newWidth = newWidther - newMargin.left - newMargin.right;

    //Change the width of the svg
    d3.select("svg")
      .attr("width", newWidth + newMargin.left + newMargin.right);

    //Change the xScale
    xScale
      .range([0, newWidth]);

    //Update the bars
    bars
      .attr("width", function(d) { return xScale(d.fire); });

    bars2
      .attr("width", function(d) { return xScale(d.alarm); });  

    bars3
      .attr("width", function(d) { return xScale(d.structural); });   

    //Updates bar labels
    barLabels
      .attr("x", function(d) { return xScale(d.fire) + 60; })
      .attr("y", y0.rangeBand()/2.6 )

    barLabels2
      .attr("x", function(d) { return xScale(d.alarm) + 60; })
      .attr("y", y0.rangeBand()/1.25 )  

    barLabels3
      .attr("x", function(d) { return xScale(d.structural) + 60; })
      .attr("y", y0.rangeBand()/0.825 )   

    //Updates xAxis
    d3.selectAll(".x.axis")
         .call(xAxis);     

    //Updates ticks
    xAxis
      .scale(xScale)
      .ticks(numTicks(newWidth));

    //Updates xAxis
    d3.selectAll(".x.axis.added")
         .call(xAxisADDED);     

    //Updates ticks
    xAxisADDED
      .scale(xScale)
      .ticks(numTicks(newWidth));  

    //Updates yAxis
    d3.selectAll(".y.axis")
      .call(yAxis); 

    yAxis
      .tickSize(-newWidth);

  };

}

//Determines number of ticks base on width
function numTicks(widther) {
  if (widther <= 400) {
    return 4
    console.log("return 4")
  }
  else {
    return 8
    console.log("return 8")
  }
}